import find from "lodash/find";
import React, { useContext } from "react";

import { RichContentDisplay } from "@examspark/common-ui";
import { Stem } from "@examspark/types";

import Mark from "../../common/Mark";
import QuestionContext from "../../QuestionContext";
import { DndItem } from "../shared/Token";

import MatchCell from "./MatchCell";

const Joint = () => {
  return (
    <div className="item-player-match-joint">
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 418.5 418.5"
        width="29"
        fill="#666"
      >
        <g>
          <g>
            <path
              d="M347,280.8c39.5,0,71.5-32.1,71.5-71.5c0-39.5-32.1-71.6-71.5-71.6c-32.8,0-61,21.9-69.2,53.4h-137
			c-8.2-31.6-36.4-53.4-69.2-53.4C32.1,137.7,0,169.8,0,209.2c0,39.5,32.1,71.6,71.5,71.6c32.8,0,61-21.9,69.2-53.4h137
			C286,258.9,314.1,280.8,347,280.8z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

type MatchPairProps = {
  dataSrc: Stem.Option[];
  dataDst: Stem.Option[];
  response: Stem.Pair | undefined;
  acceptLeft: string[];
  acceptRight: string[];
  pairs?: Stem.Pair[];
  onDrop: (from: "src" | "dst", item: DndItem) => void;
  onLeave: (side: "src" | "dst") => void;
  bidirectional?: boolean;
};
const MatchPair = (props: MatchPairProps) => {
  const [player] = useContext(QuestionContext);

  let srcContent;
  let srcItem;
  let dstContent;
  let dstItem;
  let findd;
  if (props.response) {
    if (props.response.src && props.dataSrc) {
      findd = find(props.dataSrc, ["id", props.response.src]);
      if (findd) {
        srcContent = findd.body;
        srcItem = findd;
      }
    }
    if (props.response.dst && props.dataDst) {
      findd = find(props.dataDst, ["id", props.response.dst]);
      if (findd) {
        dstContent = findd.body;
        dstItem = findd;
      }
    }
  }

  let mark: boolean | "correct" | "incorrect" = false;
  if (player.scoreResponses) {
    if (props.pairs && props.response) {
      mark = "incorrect";
      props.pairs.forEach((p) => {
        if (props.response!.dst === p.dst && props.response!.src === p.src) {
          mark = "correct";
        }
        if (props.bidirectional) {
          if (props.response!.dst === p.src && props.response!.src === p.dst) {
            mark = "correct";
          }
        }
      });
    }
  }

  return (
    <div className="item-player-match">
      <div className="item-player-match-left">
        <MatchCell
          accept={props.acceptLeft}
          onDrop={(item) => {
            props.onDrop("src", item);
          }}
          onLeave={(item) => {
            props.onLeave("src");
          }}
          content={srcItem}
        >
          <RichContentDisplay content={srcContent} />
        </MatchCell>
      </div>
      <Joint />
      <div className="item-player-match-right">
        <MatchCell
          accept={props.acceptRight}
          onDrop={(item) => {
            props.onDrop("dst", item);
          }}
          onLeave={(item) => {
            props.onLeave("dst");
          }}
          content={dstItem}
        >
          <RichContentDisplay content={dstContent} />
        </MatchCell>
      </div>
      {mark && <Mark type={mark} />}
    </div>
  );
};

export default MatchPair;
